export class FileHelpers {
  public static supportedFiles = [
    { ext: '.json', mimeType: 'application/json' },
    { ext: '.pdf', mimeType: 'application/pdf' },
    { ext: '.rtf', mimeType: 'application/rtf' },
    { ext: '.zip', mimeType: 'application/zip' },
    { ext: '.tar', mimeType: 'application/x-tar' },
    { ext: '.xml', mimeType: 'application/xml' },
    { ext: '.gz', mimeType: 'application/gzip' },
    { ext: '.bz2', mimeType: 'application/x-bzip2' },
    { ext: '.gz', mimeType: 'application/x-gzip' },
    { ext: '.smil', mimeType: 'application/smil' },
    { ext: '.js', mimeType: 'application/javascript' },
    { ext: '.m4a', mimeType: 'audio/mp4' },
    { ext: '.m4p', mimeType: 'audio/mp4' },
    { ext: '.m4b', mimeType: 'audio/mp4' },
    { ext: '.m4r', mimeType: 'audio/mp4' },
    { ext: '.mp1', mimeType: 'audio/mpeg' },
    { ext: '.mp2', mimeType: 'audio/mpeg' },
    { ext: '.mp3', mimeType: 'audio/mpeg' },
    { ext: '.m1a', mimeType: 'audio/mpeg' },
    { ext: '.m2a', mimeType: 'audio/mpeg' },
    { ext: '.mpa', mimeType: 'audio/mpeg' },
    { ext: '.oga', mimeType: 'audio/ogg' },
    { ext: '.flac', mimeType: 'audio/flac' },
    { ext: '.webm', mimeType: 'audio/webm' },
    { ext: '.wav', mimeType: 'audio/wav' },
    { ext: '.amr', mimeType: 'audio/amr' },
    { ext: '.3ga', mimeType: 'audio/amr' },
    { ext: '.3gp', mimeType: 'audio/3gpp' },
    { ext: '.bmp', mimeType: 'image/bmp' },
    { ext: '.dib', mimeType: 'image/bmp' },
    { ext: '.gif', mimeType: 'image/gif' },
    { ext: '.jpg', mimeType: 'image/jpeg' },
    { ext: '.jpeg', mimeType: 'image/jpeg' },
    { ext: '.pjpeg', mimeType: 'image/pjpeg' },
    { ext: '.png', mimeType: 'image/png' },
    { ext: '.svg', mimeType: 'image/svg+xml' },
    { ext: '.tiff', mimeType: 'image/tiff' },
    { ext: '.tif', mimeType: 'image/tiff' },
    { ext: '.webp', mimeType: 'image/webp' },
    { ext: '.ico', mimeType: 'image/x-icon' },
    { ext: '.css', mimeType: 'text/css' },
    { ext: '.csv', mimeType: 'text/csv' },
    { ext: '.html', mimeType: 'text/html' },
    { ext: '.cal', mimeType: 'text/calendar' },
    { ext: '.txt', mimeType: 'text/plain' },
    { ext: '.js', mimeType: 'text/javascript' },
    { ext: '.vcf', mimeType: 'text/vcard' },
    { ext: '.vcard', mimeType: 'text/vcard' },
    { ext: '.wap', mimeType: 'text/vnd.wap.wml' },
    { ext: '.xml', mimeType: 'text/xml' },
    { ext: '.avi', mimeType: 'video/avi' },
    { ext: '.mp4', mimeType: 'video/mp4' },
    { ext: '.m4v', mimeType: 'video/mp4' },
    { ext: '.mpg', mimeType: 'video/mpeg' },
    { ext: '.mpeg', mimeType: 'video/mpeg' },
    { ext: '.m1v', mimeType: 'video/mpeg' },
    { ext: '.mpv', mimeType: 'video/mpeg' },
    { ext: '.ogv', mimeType: 'video/ogg' },
    { ext: '.ogx', mimeType: 'video/ogg' },
    { ext: '.ogg', mimeType: 'video/ogg' },
    { ext: '.spx', mimeType: 'video/ogg' },
    { ext: '.ogm', mimeType: 'video/ogg' },
    { ext: '.mov', mimeType: 'video/quicktime' },
    { ext: '.qt', mimeType: 'video/quicktime' },
    { ext: '.webm', mimeType: 'video/webm' },
    { ext: '.wmv', mimeType: 'video/x-ms-wmv' },
    { ext: '.flv', mimeType: 'video/x-flv' },
    { ext: '.ogv', mimeType: 'application/ogg' },
    { ext: '.oga', mimeType: 'application/ogg' },
    { ext: '.ogx', mimeType: 'application/ogg' },
    { ext: '.ogg', mimeType: 'application/ogg' },
  ];

  public static supportedFaxFiles = [
    { ext: '.pdf', mimeType: 'application/pdf' },
    { ext: '.rtf', mimeType: 'application/rtf' },
    { ext: '.jpg', mimeType: 'image/jpeg' },
    { ext: '.jpeg', mimeType: 'image/jpeg' },
    { ext: '.tiff', mimeType: 'image/tiff' },
    { ext: '.tif', mimeType: 'image/tiff' },
    { ext: '.csv', mimeType: 'text/csv' },
    { ext: '.html', mimeType: 'text/html' },
    { ext: '.txt', mimeType: 'text/plain' },
    { ext: '.ps', mimeType: 'application/postscript' },
    { ext: '.doc', mimeType: 'application/msword' },
    { ext: '.docx', mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
    { ext: '.xlsx', mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
    // { ext: '.xls', mimeType: 'application/vnd.ms-excel' },
  ];
  public static supportedFaxMergeFiles = [
    { ext: '.pdf', mimeType: 'application/pdf' },
    { ext: '.jpg', mimeType: 'image/jpeg' },
    { ext: '.jpeg', mimeType: 'image/jpeg' },
    { ext: '.png', mimeType: 'image/png' },
  ];
  public static supportedCsvFiles = [{ ext: '.csv', mimeType: 'text/csv' }];
  public static supportedAudioFiles = [
    { ext: '.wav', mimeType: 'audio/wav' },
    { ext: '.mp3', mimeType: 'audio/mpeg' },
    { ext: '.oga', mimeType: 'audio/ogg' },
    { ext: '.flac', mimeType: 'audio/flac' },
    { ext: '.webm', mimeType: 'audio/webm' },
  ];

  public static getFileName(filename) {
    return (filename || '').split('/').pop();
  }

  public static getExtension(filename) {
    return '.' + (filename || 'unknown').split('.').pop();
  }

  public static getMimeType(filename) {
    const ext = FileHelpers.getExtension(filename);
    const mimeTypeObj = FileHelpers.supportedFiles.find(x => x.ext == ext);
    if (mimeTypeObj) {
      return mimeTypeObj.mimeType;
    }
    return '';
  }

  public static isSupportedFileType(
    fileType: string,
    type: 'sms' | 'fax' | 'fax_merge' | 'csv' | 'audio' = 'sms',
  ): boolean {
    let fileDefIndex = -1;

    if (type === 'sms') {
      fileDefIndex = FileHelpers.supportedFiles.findIndex(x => x.mimeType === (fileType || '').toLowerCase());
    } else if (type === 'fax') {
      fileDefIndex = FileHelpers.supportedFaxFiles.findIndex(x => x.mimeType === (fileType || '').toLowerCase());
    } else if (type === 'fax_merge') {
      fileDefIndex = FileHelpers.supportedFaxMergeFiles.findIndex(x => x.mimeType === (fileType || '').toLowerCase());
    } else if (type === 'csv') {
      fileDefIndex = FileHelpers.supportedCsvFiles.findIndex(x => x.mimeType === (fileType || '').toLowerCase());
    } else if (type === 'audio') {
      fileDefIndex = FileHelpers.supportedAudioFiles.findIndex(x => x.mimeType === (fileType || '').toLowerCase());
    }

    return fileDefIndex > -1;
  }

  public static isSupportedFileExt(
    fileExt: string,
    type: 'sms' | 'fax' | 'fax_merge' | 'csv' | 'audio' = 'sms',
  ): boolean {
    let fileDefIndex = -1;

    if (type === 'sms') {
      fileDefIndex = FileHelpers.supportedFiles.findIndex(x => x.ext === (fileExt || '').toLowerCase());
    } else if (type === 'fax') {
      fileDefIndex = FileHelpers.supportedFaxFiles.findIndex(x => x.ext === (fileExt || '').toLowerCase());
    } else if (type === 'fax_merge') {
      fileDefIndex = FileHelpers.supportedFaxMergeFiles.findIndex(x => x.ext === (fileExt || '').toLowerCase());
    } else if (type === 'csv') {
      fileDefIndex = FileHelpers.supportedCsvFiles.findIndex(x => x.ext === (fileExt || '').toLowerCase());
    } else if (type === 'audio') {
      fileDefIndex = FileHelpers.supportedAudioFiles.findIndex(x => x.ext === (fileExt || '').toLowerCase());
    }

    return fileDefIndex > -1;
  }

  public static isSupportedFile(file: File, type: 'sms' | 'fax' | 'fax_merge' | 'csv' | 'audio' = 'sms'): boolean {
    if (!file) {
      return false;
    }

    if (file.type && type !== 'csv') {
      return FileHelpers.isSupportedFileType(file.type, type);
    }

    const fileExt = FileHelpers.getExtension(file.name);

    return FileHelpers.isSupportedFileExt(fileExt, type);
  }

  public static isSupported4MbFileSize(file: File): boolean {
    if (!file) {
      return true;
    }
    console.log('file.size', file.size);
    return file.size <= 3.75 * 1024 * 1024;
  }

  public static isSupportedFaxFileSize(file: File): boolean {
    if (!file) {
      return true;
    }
    console.log('file.size', file.size);
    return file.size <= 11 * 1024 * 1024;
  }
}
